<template>
    <div v-if="bannData"  :style="bannData.layout">
        <swiper :options="swiperOption">
            <swiper-slide v-if="bannData.imglist" v-for="it,i in bannData.imglist" :key="i">
                <div :style="it.slidecss" style="text-align: center;">
                    <!--
                    <img :src="it.img" width="100%"/>
                    -->
                    <div style="width: 100%;height: 100%;max-width: 1680px;margin: 0 auto; background-size: cover;background-position: center center; background-size: cover;"
                         :style="{ backgroundImage: 'url(' + it.img + ')' }">
                    </div>


                    <a @click="goto(it)"
                       style="cursor: pointer; display: block;top:0;left: 0; position: absolute;width: 100%;height: 100%;">

                    </a>
                </div>
            </swiper-slide>




            <div v-if="bannData.imglist" class="swiper-pagination" slot="pagination"></div>

            <!--
            <div class="swiper-button-prev" style="background-color: red;" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            -->

        </swiper>

    </div>
</template>

<script>
    export default {
        name: "bann1",
        props:{
            bannData:{},
        },
        data(){
            return{
                swiperOption: {
                    loop: true, //首尾循环
                    //不想自动滚动，只需注释掉autoplay属性即可
                    autoplay: {
                        delay: 16000, //自动切换的时间间隔，单位ms
                        stopOnLastSlide: false, //true表示滚动到最后一页后停止滚动
                        disableOnInteraction: false, //true：交互后，不继续滚动
                    },
                    // centeredSlides: true, //true:当前板块居中
                    slidesPerView: 1, //页面中的板块数量

                    freeMode: false, //true:拖到哪就是哪
                    spaceBetween: 30, //板块间隔
                    grabCursor: false, //true：鼠标为抓手
                    // slidesPerGroup: 3, //多少个板块为1组。
                    // 显示分页
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true, //true：点击底部小圆点可以跳转页面
                        type: "bullets", //当前页显示 1/7 bullets’ 圆点（默认）‘fraction’ 分式 ‘progress’ 进度条‘custom’ 自定义
                    },
                    // 设置点击箭头
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                }
            }
        },
        methods:{
            goto(it){
                console.log(it);
                if(it.type==undefined){return false}

                if(it.type=='link'){
                    window.open(it.url, it.target);
                }
                if(it.type=='rout'){
                    //this.$router.push({'path': it.url, query: {'id': it.valval}});
                    var url='';
                    if(it.valval!='') {
                         url = this.$router.resolve({path: it.url, query: {'id': it.valval}}).href;
                    }
                    if(it.valval==''){
                        url = this.$router.resolve({path: it.url}).href;
                    }
                    if(url!='') {
                        window.open(url, it.target);
                    }

                }


            },
        },
    }
</script>

<style scoped>
    .slid1{
        width: 100%;height: 600px;
        max-width: 1920px;
        background-color: #ffffff;
        margin: 0 auto;
        position: relative;
    }

    /deep/ .swiper-pagination-bullet-active{
        background-color: #f0010c!important;
    }
    /deep/ .swiper-pagination-bullet{
        width: 20px;border-radius: 0;
    }
    /deep/ .swiper-button-prev, .swiper-button-next{

    }

</style>



// WEBPACK FOOTER //
// src/components/comp/bann1.vue